import { Button, Input } from "antd"
import styles from './index.module.less'
import './index.less'
export default function CustomPhone(props) {
    const { value, onChange, callback, count, showtime } = props
    return <div>
        <Input value={value} onChange={(e) => {
            onChange(e.target.value)
        }} placeholder="请输入手机号" />
        <Button id='submitphonebtn'
        // className={styles.verification}
         onClick={callback} disabled={showtime} >{showtime ? `${count}秒` : '获取验证码'}</Button>
    </div>
}
